import { useEffect, useRef, useState } from "react";
import { Panel } from "primereact/panel";
import { Checkbox } from "primereact/checkbox";
import {
  handleSelectAll,
  handleSelectOption,
  isAllSelected,
} from "../../../../../../../../utils/filterBy/filterBy";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { RadioButton } from "primereact/radiobutton";

const segmentsData = [
  "Hand Puller",
  "HandHeld Tool",
  "Non-User",
  "Not Roundup",
  "Roundup",
];

const byGendersData = [
  { lable: "Male", value: "male" },
  { lable: "Female", value: "female" },
  { lable: "Non-Binary", value: "nonbinary" },
  { lable: "All", value: "all" },
];

const byAgeRangeData = [
  { label: "Under 18 Years", value: "0-18" },
  { label: "18-24", value: "18-24" },
  { label: "25-29", value: "25-29" },
  { label: "30-34", value: "30-34" },
  { label: "35-39", value: "35-39" },
  { label: "40-44", value: "40-44" },
  { label: "45-49", value: "45-49" },
  { label: "50-54", value: "50-54" },
  { label: "55-59", value: "55-59" },
  { label: "60-64", value: "60-64" },
  { label: "65-69", value: "65-69" },
  { label: "70+ Years", value: "70-130" },
];

const SurveyXmotFilter = ({
  hideFilter = false,
  handleHideFilter,
  filterSegmentsData,
  usersLocationData,
  selectedFiltersData,
  handleApplyFilters,
  handleSetSelectedFilter,
}) => {
  const [maxHeight, setMaxHeight] = useState("90vh");
  const {
    selectedSegments,
    selectedGender,
    selectedAgeRange,
    selectedLocations,
  } = selectedFiltersData;
  const refSegment = useRef(null);
  const refGender = useRef(null);
  const refAgeRange = useRef(null);
  const refLocation = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const sidebar = document.querySelector(".sticky-sidebar");
      if (sidebar) {
        const parent = sidebar.parentElement; // Get the `.row` automatically
        const parentBottom = parent.getBoundingClientRect().bottom;
        const windowHeight = window.innerHeight;

        // Prevent height from shrinking when reaching the bottom
        const newHeight =
          parentBottom > windowHeight
            ? "calc(100vh - 130px)"
            : `${Math.max(parentBottom - 130, 300)}px`; // Ensure minimum height

        setMaxHeight(newHeight);
      }
    };

    window.addEventListener("scroll", handleResize);
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call

    return () => {
      window.removeEventListener("scroll", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSegmentChange = (e) => {
    const { value, checked } = e.target;
    let updatedSelectedSegments;

    if (value === "ALL") {
      updatedSelectedSegments = handleSelectAll(selectedSegments, segmentsData);
    } else {
      updatedSelectedSegments = handleSelectOption(selectedSegments, value);
    }

    handleSetSelectedFilter("selectedSegments", updatedSelectedSegments);
  };

  const handleLocationChange = (e) => {
    const { value, checked } = e.target;
    let updatedSelectedLocations;

    if (value === "ALL") {
      updatedSelectedLocations = handleSelectAll(
        selectedLocations,
        usersLocationData,
      );
    } else {
      updatedSelectedLocations = handleSelectOption(selectedLocations, value);
    }

    handleSetSelectedFilter("selectedLocations", updatedSelectedLocations);
  };

  const handleGenderChange = (e) => {
    const { value, checked } = e.target;

    handleSetSelectedFilter("selectedGender", value);
  };

  const handleAgeRangeChange = (e) => {
    const { value, checked } = e.target;
    let updatedSelectedSegments;

    if (value === "all") {
      if (selectedAgeRange.length === byAgeRangeData.length) {
        updatedSelectedSegments = [];
      } else {
        updatedSelectedSegments = [
          ...byAgeRangeData.map((ageRangeVal) => ageRangeVal?.value),
        ];
      }
    } else {
      updatedSelectedSegments = handleSelectOption(selectedAgeRange, value);
    }

    handleSetSelectedFilter("selectedAgeRange", updatedSelectedSegments);
  };

  return (
    <>
      <div
        className={`filter-wrapper p-0 ${hideFilter ? "hide-filter" : "col-sm-3"}`}
        style={{ marginTop: "2px" }}
      >
        <div
          className="filter-hide-toggle"
          onClick={() => handleHideFilter(!hideFilter)}
        >
          <i
            className={`pi ${hideFilter ? "pi-angle-right" : "pi-angle-left"}`}
          ></i>
        </div>
        <div
          className={`sticky-sidebar`}
          style={{
            borderRight: hideFilter ? "3px solid #dee2e6" : "1px solid #dee2e6",
            paddingLeft: !hideFilter ? "12px" : "0",
            paddingRight: !hideFilter ? "12px" : "0",
            // position: "sticky", //removed sticky position filters
            // top: "115px",
            // height: maxHeight,
            height: "100%",
            overflowY: "auto",
            background: "white",
            zIndex: 10,
          }}
        >
          <div className="filter-header-row">
            <span
              className="d-contents fs-5 mb-0 fw-600"
              style={{ color: "#000" }}
            >
              Filter By:
            </span>
          </div>

          {filterSegmentsData?.length > 0 ? (
            <>
              <Panel
                className="my-3 text-start cursor-pointer"
                ref={refSegment}
                header={
                  <span
                    onClick={() => refSegment.current.toggle()}
                    style={{ cursor: "pointer" }}
                  >
                    By Segments
                  </span>
                }
                toggleable
                expandIcon="pi pi-angle-up"
                collapseIcon="pi pi-angle-down"
                collapsed={true}
                // onClick={() => refSegment.current.toggle()}
              >
                <div className="flex flex-column gap-3 filter-panel">
                  {filterSegmentsData.map((segment, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex align-items-center pt-2 pb-2"
                      >
                        <Checkbox
                          inputId={`segments-${index}`}
                          value={segment}
                          onChange={handleSegmentChange}
                          checked={selectedSegments?.includes(segment)}
                        />
                        <label
                          htmlFor={`segments-${index}`}
                          className="ml-2 ps-2"
                        >
                          {segment}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Panel>
              <Divider />
            </>
          ) : (
            ""
          )}

          {byGendersData.length > 0 ? (
            <>
              <Panel
                className="my-3 text-start cursor-pointer"
                ref={refGender}
                header={
                  <span
                    onClick={() => refGender.current.toggle()}
                    style={{ cursor: "pointer" }}
                  >
                    By Gender
                  </span>
                }
                toggleable
                expandIcon="pi pi-angle-up"
                collapseIcon="pi pi-angle-down"
                collapsed={true}
                // onClick={() => refGender.current.toggle()}
              >
                <div className="d-flex flex-wrap gap-3 filter-panel">
                  {(byGendersData?.length > 0 ? [...byGendersData] : []).map(
                    (gender, index) => {
                      return (
                        <div
                          key={index}
                          className="d-flex align-items-center pt-2 pb-2"
                        >
                          <RadioButton
                            inputId={`gender-${index}`}
                            value={gender?.value}
                            onChange={handleGenderChange}
                            name={`by_gender${index}`}
                            checked={selectedGender === gender?.value}
                          />
                          <label
                            htmlFor={`gender-${index}`}
                            className="ml-2 ps-2"
                          >
                            {gender?.lable}
                          </label>
                        </div>
                      );
                    },
                  )}
                </div>
              </Panel>
              <Divider />
            </>
          ) : (
            ""
          )}

          {byAgeRangeData.length > 0 ? (
            <>
              <Panel
                className="my-3 text-start cursor-pointer"
                ref={refAgeRange}
                header={
                  <span
                    onClick={() => refAgeRange.current.toggle()}
                    style={{ cursor: "pointer" }}
                  >
                    By Age Range
                  </span>
                }
                toggleable
                expandIcon="pi pi-angle-up"
                collapseIcon="pi pi-angle-down"
                collapsed={true}
                // onClick={() => refAgeRange.current.toggle()}
              >
                <div className="flex flex-column gap-3 filter-panel">
                  {(byAgeRangeData?.length > 0
                    ? [{ label: "All", value: "all" }, ...byAgeRangeData]
                    : []
                  ).map((ageRange, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex align-items-center pt-2 pb-2"
                      >
                        <Checkbox
                          inputId={`ageRange-${index}`}
                          value={ageRange?.value}
                          onChange={handleAgeRangeChange}
                          checked={
                            ageRange?.value === "all"
                              ? isAllSelected(selectedAgeRange, byAgeRangeData) // Skip 'ALL'
                              : selectedAgeRange?.includes(ageRange?.value)
                          }
                        />
                        <label
                          htmlFor={`ageRange-${index}`}
                          className="ml-2 ps-2"
                        >
                          {ageRange?.label}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Panel>
              <Divider />
            </>
          ) : (
            ""
          )}
          {usersLocationData?.length > 0 ? (
            <>
              <Panel
                className="my-3 text-start cursor-pointer"
                ref={refLocation}
                header={
                  <span
                    onClick={() => refLocation.current.toggle()}
                    style={{ cursor: "pointer" }}
                  >
                    By Locations
                  </span>
                }
                toggleable
                expandIcon="pi pi-angle-up"
                collapseIcon="pi pi-angle-down"
                collapsed={true}
                // onClick={() => refLocation.current.toggle()}
              >
                <div className="flex flex-column gap-3 filter-panel">
                  {usersLocationData?.map((loc, index) => {
                    return (
                      <div
                        key={index}
                        className="d-flex align-items-center pt-2 pb-2"
                      >
                        <Checkbox
                          inputId={`locations-${index}`}
                          value={loc?.city_id}
                          onChange={handleLocationChange}
                          checked={selectedLocations?.includes(loc?.city_id)}
                        />
                        <label
                          htmlFor={`locations-${index}`}
                          className="ml-2 ps-2"
                        >
                          {loc?.location}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Panel>
              <Divider />
            </>
          ) : (
            ""
          )}

          <div className="d-flex align-items-center justify-content-center gap-2 managed-row mt-3">
            <Button
              label="Reset"
              className="p-button-text me-2 resetButton br-c fw-600"
              style={{ width: "120px", color: "gray" }}
              onClick={() => {
                handleSetSelectedFilter("reset");
                handleApplyFilters({
                  selectedSegments: null,
                  selectedGender: null,
                  selectedAgeRange: null,
                  selectedLocations: null,
                });
              }}
              disabled={
                selectedSegments?.length === 0 &&
                selectedAgeRange?.length === 0 &&
                selectedLocations?.length === 0 &&
                selectedGender === null
              }
            ></Button>
            <Button
              label="Apply"
              className="p-button-text me-2  active-button br-c fw-600"
              style={{ width: "120px" }}
              disabled={
                selectedSegments?.length === 0 &&
                selectedAgeRange?.length === 0 &&
                selectedLocations?.length === 0 &&
                selectedGender === null
              }
              onClick={() => {
                handleApplyFilters({
                  selectedSegments,
                  selectedGender,
                  selectedAgeRange,
                  selectedLocations,
                });
              }} // Pass selected filters to parent
            ></Button>
          </div>
          <Divider align="center"></Divider>
        </div>
      </div>
    </>
  );
};

export default SurveyXmotFilter;
